// transform an array into a list of number -> 12 => [1, 2]
export const arr = (value: number) =>
  String(value)
    .split("")
    .map((num) => {
      return Number(num);
    });
